import type { FaireProductEntity } from "../../entity_types/product";

export const p_cfa9uzv4xp: FaireProductEntity = {
  token: "p_cfa9uzv4xp",
  type: "product",
  name: "horse mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5d9fdedb0c1c6cb421770f37cf62c2d8b3d484907ae3e7f1de125913ed76be95.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• single card + envelope\n• blank inside\n• 2.5" x 3.5"\n• Printed on 120lb superfine paper',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:50.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
